__turbopack_context__.v({
  "actions": "Confirm-module__xbKUrG__actions",
  "background": "Confirm-module__xbKUrG__background",
  "box": "Confirm-module__xbKUrG__box",
  "closed": "Confirm-module__xbKUrG__closed",
  "message": "Confirm-module__xbKUrG__message",
  "title": "Confirm-module__xbKUrG__title",
});
